import { useContext } from 'react'

import HideMobileMenu from './HideMobileMenu'
import MobileMenuControlsProvider, {
  IMobileMenuControlsContextProps as IContextProps,
  MobileMenuControlsContext,
} from './Provider'

export { MobileMenuControlsProvider, MobileMenuControlsContext, HideMobileMenu }

export type IMobileMenuControlsContextProps = IContextProps

export const useMobileMenuControls = () => useContext(MobileMenuControlsContext)
